const LOGIN_RETURN_KEY = "doggy_dynamo.login_return"

export function isSafeReturnPath(path: string): boolean {
  if (!path.startsWith("/")) return false
  if (path.startsWith("//")) return false
  if (path.startsWith("/login")) return false
  return true
}

export function storeLoginReturnPath(path: string): void {
  if (!isSafeReturnPath(path)) return
  sessionStorage.setItem(LOGIN_RETURN_KEY, path)
}

export function getLoginReturnPath(searchParams: URLSearchParams): string {
  const fromQuery = searchParams.get("return")
  if (fromQuery && isSafeReturnPath(fromQuery)) return fromQuery

  const fromStorage = sessionStorage.getItem(LOGIN_RETURN_KEY)
  if (fromStorage && isSafeReturnPath(fromStorage)) return fromStorage

  return "/dashboard"
}

export function clearLoginReturnPath(): void {
  sessionStorage.removeItem(LOGIN_RETURN_KEY)
}
